import React from 'react';
import { channelTypeSingleOptions } from '../../constants/channelType';
import { SingleCommonType } from '../../types';
import { channelTypePlaceholder } from '../../constants/placeholder';
import CommonSingleSelect from '../../components/CommonSingleSelect';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';

export default function ChannelTypeSingleSelect(props: SingleCommonType) {
  return (
    <CommonSingleSelect
      {...props}
      returnKey="channel_single_type"
      singlePlaceholder={channelTypePlaceholder}
      options={channelTypeSingleOptions}
      pointKey={FilterButtonPoint.channelTypeSingle}
      initValue="game store"
    />
  );
}
